import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';
import { withRouter } from "react-router-dom";


import { changeProject } from '../../actions/projects';

class SettingsMenu extends Component {
    constructor(props) {
        super(props);

        this.toggle = this.toggle.bind(this);
        this.state = {
            dropdownOpen: false,
        };
    }

    toggle() {
        this.setState({
            dropdownOpen: !this.state.dropdownOpen,
        });
    }

    routeTo(path) {
        document.body.classList.remove('sidebar-lg-show');
        const { changeProject, history } = this.props;
        changeProject(null);
        history.push(path);
    }

    render() {
        const {  logged_user } = this.props;
        return (
            <Dropdown nav className="d-md-down-none" isOpen={this.state.dropdownOpen} toggle={this.toggle}>
                <DropdownToggle nav>
                    <i className="icon-settings"></i>
                </DropdownToggle>
                <DropdownMenu className="dropdown-menu-lg" right>
                    <DropdownItem header tag="div" className="text-center"><strong>Enterprise Settings</strong></DropdownItem>
                    <DropdownItem header tag="div" className="text-center"><strong>{logged_user? logged_user.organization.name : "Settings"}</strong></DropdownItem>
                    <DropdownItem onClick={() => this.routeTo("/settings/usermanagement")}><i className="icon-user"></i> User Management</DropdownItem>
                    <DropdownItem onClick={() => this.routeTo("/settings/security")}><i className="icon-key"></i> Security Settings</DropdownItem>
                    <DropdownItem onClick={() => this.routeTo("/settings/cloudstorage")}><i className="icon-drawer"></i> Cloud Storage</DropdownItem>
                    <DropdownItem onClick={() => this.routeTo("/settings/localstorage")}><i className="icon-drawer"></i> Local Storage</DropdownItem>
                </DropdownMenu>
            </Dropdown>
        );
    }
}

function mapStateToProps({ logged_user }) {
    return {
        logged_user
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        changeProject
    }, dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SettingsMenu));



// WEBPACK FOOTER //
// ./src/containers/menus/SettingsMenu.js